export default __webpack_public_path__ + "static/media/about-game.019f93b4.svg";